let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("43Egm")).then(() => parcelRequire('efGEo'));